/* All intellectual property rights in the software, code and associated materials ("Software") belong to Leo Learning Limited and its licensors. All rights in the Software are expressly reserved by and to Leo Learning Limited and its licensors. Without limiting the generality of the foregoing, users of the Software are not permitted to (and agree not to) reproduce, copy or otherwise duplicate, and not to distribute, lend or otherwise transfer the Software or any part of it without the express written permission of Leo Learning Limited. Each user also undertakes not to use the Software in any way that would compromise the confidential and proprietary nature of the Software. Each user undertakes to use the Software only in accordance with the terms of the respective user license and not to resell, reproduce, sell, modify the Software in any way and acknowledges that it has no permission to so do. */ // eslint-disable-line max-len
import React from 'react'; // eslint-disable-line no-unused-vars

import { objectWithoutProperties } from 'utils';


const FieldWithError = (props) => {
  const {
    innerComponent: Component, input, type, meta, // eslint-disable-line react/prop-types
  } = props;
  const restProps = objectWithoutProperties(props, ['innerComponent', 'input', 'meta']);
  return (
    <div>
      {meta.touched && meta.error && (
        <span className="error">{meta.error}</span>
      )}
      <Component {...input} type={type} {...restProps} />
    </div>
  );
};

export default FieldWithError;
